import translate from "../i18n/translate";

/** HTTP or API-level code indicates missing auth / permission — avoid noisy global toasts. */
export function isAuthDeniedError(error) {
    if (!error.response) return false;
    const status = error.response.status;
    if (status === 401 || status === 403) return true;
    const data = error.response.data;
    const code = data && data.code;
    if (code === 401 || code === 403) return true;
    return false;
}

export function isAuthorized(error) {
    return (error.response && error.response.data && error.response.data.code !== 401);
}

export function isMessageError(error) {
    return (error.response && error.response.data && error.response.data.message);
}

export function getError(e, store) {
    const authorized = isAuthorized(e);
    if (!authorized) {
        return false;
    }
    if (e.response && e.response.data && e.response.data.message) {
        store.error = { message: e.response.data.message }
    } else {
        store.error = { message: translate('default.errorOccurred') }
    }
    return true;
}